<template>
  <div class="flex items-center justify-between py-2.5">
    <div class="flex items-center gap-2">
      <span
        class="flex items-center justify-center w-7 h-7 rounded-md bg-app-primary/10"
      >
        <FilmIcon class="w-4 h-4 text-app-primary" />
      </span>
      <span class="text-xs font-semibold text-untitled-gray-700">
        Upcoming Events
      </span>
    </div>
    <div>
      <el-dropdown trigger="click">
        <el-button size="small" class="!rounded-md !text-untitled-gray-600">
          Options
          <el-icon class="el-icon--right">
            <ChevronDownIcon class="w-3.5 h-3.5" />
          </el-icon>
        </el-button>
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item
              @click="handleClickCreateNewEvent"
              v-if="useLmsSettingsStore().isRestrictLearner"
            >
              <PlusIcon class="w-4 h-4 text-untitled-gray-500 mr-2" />
              <span class="text-xs font-medium text-untitled-gray-700"
                >Create Event</span
              >
            </el-dropdown-item>
            <el-dropdown-item @click="handleClickViewAllEvents">
              <EyeIcon class="w-4 h-4 text-untitled-gray-500 mr-2" />
              <span class="text-xs font-medium text-untitled-gray-700"
                >View All Events</span
              >
            </el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </div>
  </div>
</template>

<script setup>
import {
  ChevronDownIcon,
  FilmIcon,
  PlusIcon,
  EyeIcon,
} from "@heroicons/vue/outline";
import {
  ElDropdown,
  ElDropdownItem,
  ElDropdownMenu,
  ElButton,
  ElIcon,
} from "element-plus";
import { useRouter } from "vue-router";
import { useLmsSettingsStore } from "@/stores/useLmsSettingsStore";

const router = useRouter();

const handleClickCreateNewEvent = () => {
  router.push({ name: "create-event-page" });
};

const handleClickViewAllEvents = () => {
  router.push({ name: "events" });
};
</script>

<style lang="scss" scoped></style>
